import type { BulkUpdateTask } from '@/generated/http-clients/v3ApiSchemas'
import { Box, Icon } from '@chakra-ui/react'
import {
  CheckCircle,
  CircleAlert,
  FileCheck,
  FilePlus,
  FileX,
  Hourglass,
  LoaderCircle,
  XCircle,
} from 'lucide-react'
import type React from 'react'
import { augmentBulkUpdateTask } from '../ClusterConfigs/pages/ClusterUpdateTable/utils'
import styles from './clusterUpdateTaskStatus.module.css'

interface ClusterUpdateTaskStatusProps {
  task: BulkUpdateTask
}

const ClusterUpdateTaskStatusIcon: React.FC<ClusterUpdateTaskStatusProps> = ({
  task,
}) => {
  const augmentedTask = augmentBulkUpdateTask(task)

  function taskStatusIcon() {
    if (augmentedTask.isSubmitted) {
      return <Icon as={FilePlus} size="md" color="gray.500" />
    }

    if (augmentedTask.isApproved) {
      return <Icon as={FileCheck} size="md" color="green.500" />
    }

    if (augmentedTask.isRejected) {
      return <Icon as={FileX} size="md" color="red.500" />
    }

    if (augmentedTask.isPending) {
      return <Icon as={Hourglass} size="md" color="gray.500" />
    }

    if (augmentedTask.isStarted) {
      return (
        <Icon
          as={LoaderCircle}
          size="md"
          color="blue.500"
          className={styles.rotatingCw}
        />
      )
    }

    if (augmentedTask.isCompleted) {
      return <Icon as={CheckCircle} size="md" color="green.600" />
    }

    if (augmentedTask.isFailed) {
      return <Icon as={XCircle} size="md" color="red.600" />
    }

    // By default, display a warning
    return <Icon as={CircleAlert} size="md" color="orange.500" />
  }

  return <Box paddingY="0.25rem">{taskStatusIcon()}</Box>
}

export default ClusterUpdateTaskStatusIcon
